import React from 'react';
import { Link } from 'react-router-dom';
import ErrorImage from '../../assets/images/chemical-not-found.png';

const index = () => {
  return (
    <section className="error-wrap">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-10">
            <div className="text-center">
              <img src={ErrorImage} className="img-fluid" alt="" />
              <p>
                OOPS !!!! No chemical properties found for this chemical in our
                database yet. We are working on it and will let you know when it
                is available.
              </p>
              <Link to="/">
                {' '}
                <a className="btn search-btn" href="/">
                  Back To Home
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default index;
